import React from 'react';

import { TagCheckbox } from '@components/atoms/TagCheckbox';
import * as S from './styles';
import { IProps } from './types';

export const TagsFilter: React.FC<IProps> = ({
  name,
  values,
  onValueClick,
}: IProps) => (
  <S.Wrapper>
    {values &&
      values.map((value) => (
        <TagCheckbox
          key={value.id}
          name={name}
          checked={!!value.selected}
          onChange={() => onValueClick(value)}
          value={value}
        />
      ))}
  </S.Wrapper>
);

TagsFilter.displayName = 'TagsFilter';
